// import jsonp from 'jsonp'
import wx from 'weixin-js-sdk'
import {
  request
} from '@/tools'
import Vue from 'vue'
import axios from 'axios'

const verSign = async (apiList, cb) => {
  // NODE_ENV
  const WX_VER_URL = Vue.prototype.$WX_VER_URL || process.env.WX_VER_URL

  return new Promise((resolve, reject) => {
    request({
      url: WX_VER_URL + encodeURIComponent(window.location.href.split('#')[0]),
      method: 'get'
    }).then(res => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList: apiList
      })
      wx.ready(() => {
        cb && cb(wx, res)
        resolve(wx)
      })
    }).catch(
      err => console.log(err))
    // jsonp(WX_VER_URL + encodeURIComponent(window.location.href.split('#')[0]), null, (err, data) => {
    //   if (err) {
    //     console.log('err')
    //     reject(err)
    //   } else {
    //     // NODE_ENV !== 'development'
    //     data = data.data
    //     wx.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: data.appId,
    //       timestamp: data.timestamp,
    //       nonceStr: data.nonceStr,
    //       signature: data.signature,
    //       jsApiList: apiList
    //     })
    //     wx.ready(() => {
    //       cb && cb(wx, data)
    //       resolve(wx)
    //     })
    //   }
    // })
  })
}
const signatureVerify = (apiList, appId, cb) => {
  // NODE_ENV
  // const WX_SIGN_URL = Vue.prototype.$WX_SIGN_URL
  return new Promise((resolve, reject) => {
    // request({
    //   url: `${WX_SIGN_URL}/wxShare/abinShareSignature?wxShareUrl=${encodeURIComponent(window.location.href.split('#')[0])}&appid=${appId}`,
    //   method: 'get'
    // }).then(res => {
    //   wx.config({
    //     debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //     appId,
    //     timestamp: res.timestamp,
    //     nonceStr: res.nonceStr,
    //     signature: res.signature,
    //     jsApiList: apiList
    //   })
    //   wx.ready(() => {
    //     cb && cb(wx, res)
    //     resolve(wx)
    //   })
    // }).catch(err => console.log(err))

    axios.get(`/prod-api/reach/wxShare/abinShareSignature?wxShareUrl=${encodeURIComponent(window.location.href.split('#')[0])}&appid=${appId}`).then(response => {
      const {data} = response.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId,
        timestamp: data.wxTimestamp,
        nonceStr: data.wxNoncestr,
        signature: data.wxSignature,
        jsApiList: apiList
      })
      wx.ready(() => {
        cb && cb(wx, data)
        resolve(wx)
      })
      wx.error((res) => {
        console.log('wechat config error', res)
      })
    }).catch(err => console.log(err))
  })
}

export {
  verSign,
  signatureVerify
}



// WEBPACK FOOTER //
// ./src/third/wx.js